export default {
  '/busca-parceiro': {
    hideHeader: true,
    hideSidebar: true
  }
}
